import { render, staticRenderFns } from "./OrgMapping.vue?vue&type=template&id=d07a10f8&scoped=true"
import script from "./OrgMapping.vue?vue&type=script&lang=js"
export * from "./OrgMapping.vue?vue&type=script&lang=js"
import style0 from "./OrgMapping.vue?vue&type=style&index=0&id=d07a10f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07a10f8",
  null
  
)

export default component.exports